import React, { useState, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLanguage } from './LanguageProvider';
import { color } from 'framer-motion';

function ChatComponent() {
  const { language } = useLanguage();

  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const userName = useRef('');
  const messagesContainerRef = useRef(null);
  const [chatPosition, setChatPosition] = useState('-16.5rem');



  useEffect(() => {
    userName.current = `user_${uuidv4()}`;
  }, []);

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSendClick = async () => {
    if (message.trim() === '') {
      return;
    }

    try {
      const queryParams = new URLSearchParams({
        userName: userName.current,
        messageText: message,
      });

      // const url = `https://levelgroup.onrender.com/api/send-message?${queryParams.toString()}`;
      const url = `http://localhost:8080/api/send-message?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        console.log('Message sent successfully');

        setMessage('');
        fetchMessages();
      } else {
        console.log('Failed to send message');
      }
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const fetchMessages = async () => {
    try {
      // const response = await fetch('https://levelgroup.onrender.com/api/get-messages');
      const response = await fetch('http://localhost:8080/api/get-messages');
      if (response.ok) {
        const data = await response.json();
        setMessages(data);
        scrollToBottom();
      } else {
        console.log('Failed to fetch messages');
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    fetchMessages();
    const intervalId = setInterval(fetchMessages, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const toggleChatPosition = () => {
    setChatPosition(chatPosition === '-16.5rem' ? '0' : '-16.5rem');
  };

  return (
    <div className='castom-chat' style={{ bottom: chatPosition }}>
      <div className="chat h-100 w-100">
        <div className="chat-title">
          <div className='title-img'></div>
          <div className='title-text'>LevelGroup live chat</div>
          <div className='title-but' onClick={toggleChatPosition}>
            {chatPosition === '-16.5rem' ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#c6c6c6bf" className="bi bi-chevron-up" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#c6c6c6bf" className="bi bi-chevron-down" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
              </svg>
            )}
          </div>
        </div>

        <div className="messages" ref={messagesContainerRef}>
          <div className="messages-content">
            <div className="message">{language === 'en' ? "Need professional help? Talk with a Level Group property expert now!" : "Потрібна професійна допомога? Поговоріть із експертом із нерухомості Level Group зараз!"}</div>


            {messages && messages.map((msg, index) => {
              const parsedMessage = JSON.parse(msg);
              return (
                parsedMessage.userName === userName.current && (
                  <div className="message" key={index} style={{ color: parsedMessage.messageType === "outgoing" ? 'white' : 'red' }}>
                    {parsedMessage.text}
                  </div>
                )
              );
            })}


          </div>
        </div>

        <div className="message-box">
          <textarea
            type="text"
            className="message-input"
            placeholder={language === 'en' ? "Type message..." : "Введіть повідомлення..."}
            value={message}
            onChange={handleInputChange}
          ></textarea>
          <button
            type="submit"
            className="message-submit"
            onClick={handleSendClick}
          >
            {language === 'en' ? "SEND" : 'НАДІСЛАТИ'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatComponent;
